import React from 'react';
import { Row, Typography, Col } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const FormItemError: React.FC = (props) => {
  return (
    <Text type="danger" className="font_15">
      <div className="flex">
        {Object.keys(props).length > 0 && props.children !== ' ' && (
          <div className="mr-8">
            <ExclamationCircleOutlined />
          </div>
        )}
        {props.children}
      </div>
    </Text>
  );
};
export default FormItemError;
